import { TApplicationState } from 'shared/mf-infrastructure/types/redux';

export function selectIsMobileView(state: TApplicationState): boolean {
  return state.page.isMobileView;
}
